/** @jsxImportSource @emotion/react */
import React, { useState } from 'react';
import type { PageType, ViewMode } from 'models/setup/PrjSchedule';
import PrjScheduleManagementPage from './schedule/PrjScheduleManagementPage';
import PrjScheduleCalendarPage from './schedule/PrjScheduleCalendarPage';

export interface CalendarProps {
  setPageMode: React.Dispatch<React.SetStateAction<PageType>>;
  viewMode: ViewMode;
  setViewMode: React.Dispatch<React.SetStateAction<ViewMode>>;
}

const PrjSchedulePage = () => {
  const [pageMode, setPageMode] = useState<PageType>('calendar');
  const [viewMode, setViewMode] = useState<ViewMode>('month');

  return (
    <>
      {pageMode === 'calendar' ? (
        <PrjScheduleCalendarPage
          setPageMode={setPageMode}
          viewMode={viewMode}
          setViewMode={setViewMode}
        />
      ) : (
        <PrjScheduleManagementPage
          setPageMode={setPageMode}
          viewMode={viewMode}
          setViewMode={setViewMode}
        />
      )}
    </>
  );
};

export default PrjSchedulePage;
